import React from "react";
import { useNavigate } from "react-router-dom";
import IntonationHelpModal from "../components/intonation/IntonationHelpModal";

export default function IntonationHelpPage() {
  const navigate = useNavigate();

  return (
    <IntonationHelpModal
      open={true}
      onClose={() => navigate("/")}
    />
  );
}